import { Link, createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { PageHeader } from '@/components/page-header'
import {
  SchoolProposalsBoard,
  type ProposalsTab,
} from '@/components/schools/school-proposals-board'
import { Button } from '@/components/ui/button'

export type ZgloszeniaSearch = { state: ProposalsTab; school?: number; page?: number }

const positiveInt = (value: unknown): number | undefined => {
  const n = Number(value)
  return Number.isInteger(n) && n > 0 ? n : undefined
}

export function parseZgloszeniaSearch(search: Record<string, unknown>): ZgloszeniaSearch {
  const school = positiveInt(search.school)
  const page = positiveInt(search.page)
  return {
    state: search.state === 'decided' ? 'decided' : 'pending',
    ...(school ? { school } : {}),
    ...(page && page > 1 ? { page } : {}),
  }
}

export const Route = createFileRoute('/_panel/szkoly/zgloszenia')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'superadmin' && me.data.role !== 'admin') {
      throw redirect({ to: '/' })
    }
  },
  validateSearch: parseZgloszeniaSearch,
  component: SchoolProposalsPage,
})

function SchoolProposalsPage() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <>
      <PageHeader
        title="Zgłoszenia nauczycieli"
        actions={
          <Button asChild variant="ghost" size="sm">
            <Link to="/szkoly">← Wróć do szkół</Link>
          </Button>
        }
      />
      <div className="p-6">
        <SchoolProposalsBoard
          tab={search.state}
          school={search.school}
          page={search.page ?? 1}
          onChange={(next) =>
            void navigate({
              search: (prev) => {
                const merged = {
                  state: next.tab ?? prev.state,
                  school: next.school === undefined ? prev.school : (next.school ?? undefined),
                  page: next.page ?? prev.page,
                }
                return parseZgloszeniaSearch(merged)
              },
            })
          }
        />
      </div>
    </>
  )
}
